
import AttSchedule from './att-schedule.vue';
import ReviewBox from './review-box.vue';

export default {
    name: "AttReview",
    components: {
        AttSchedule,
        ReviewBox
    },
    created() {

        let t = this;

        // {
        //                 'id': 1,
        //                 'text': '時間変更',
        //                 'count': 0
        //             },
        //             {
        //                 'id': 2,
        //                 'text': '直行直帰',
        //                 'count': 0
        //             },
        //             {
        //                 'id': 3,
        //                 'text': '休み変更',
        //                 'count': 0
        //             },
        //             {
        //                 'id': 5,
        //                 'text': '休暇申請',
        //                 'count': 0
        //             },
        //             {
        //                 'id': 4,
        //                 'text': 'シフト表',
        //                 'count': 0
        //             }

        if (t.U.grant.clock_in_review == 1) {
            t.list.type.push(
                {
                    'id': 1,
                    'text': '時間変更',
                    'count': 0
                },
            );

            t.list.type.push(
                {
                    'id': 2,
                    'text': '直行直帰',
                    'count': 0
                },
            );

        }


        if (t.U.grant.leave_review == 1) {
            t.list.type.push(
                {
                    'id': 5,
                    'text': '休暇申請',
                    'count': 0
                },
            );

            t.list.type.push(
                {
                    'id': 3,
                    'text': '休み変更',
                    'count': 0
                }
            );
        }

        if (t.U.grant.att_schedule_review == 1) {
            t.list.type.push(
                {
                    'id': 4,
                    'text': 'シフト表',
                    'count': 0
                }
            );
        }


        t.search.type = t.list.type[0];

        t.search.attMonth = (new Date()).format('yyyy-MM');

        t.selectedMonth = new Date(t.search.attMonth + '-01');

        t.dict.status = listToDict(t.list.status);

        axios.get('unit').then(res => {
            if (res.data.status == 1) {

                let arr = res.data.options.items;

                arr.forEach(item => {
                    item.children = [
                    ];
                    item.text = item.name;
                });

                let arr2 = [{ 'id': 0, 'text': '無所属', 'children': [] }];

                t.list.unit = arr2.append(arr);;

                t.dict.unit = listToDict(t.list.unit);

                axios.get('employee?role=4&_with=config').then(res => {
                    if (res.data.status == 1) {
                        let arr = res.data.options.items;
                        t.list.employee = [];
                        t.list.employee2 = [];
                        arr.forEach(e => {
                            e.fullname = e.name;
                            e.text = e.fullname;
                            if (e.id == t.U.id) {
                                return;
                            }
                            t.list.employee.push(e);

                            if (e.config) {
                                let unit = t.dict.unit[e.config.unit_id];
                                if (unit) {
                                    unit.children.push(e);
                                }
                                else {
                                    this.list.unit[0].children.push(e);
                                }
                            }
                            else {
                                this.list.unit[0].children.push(e);
                            }

                        });

                        if (t.list.unit[0].children.length == 0) {
                            t.list.unit.remove(t.list.unit[0]);
                        }

                        t.list.unit2 = [
                            {
                                'id': 0, 'text': 'すべて', 'children': [{ 'id': 0, 'text': '--' }]
                            },
                        ];
                        t.list.unit.forEach(unit => {
                            if (unit.children.length > 0) {
                                t.list.unit2.push(unit);
                            }
                        });

                        t.dict.employee = listToDict(t.list.employee);

                        // t.list.employee.unshift({
                        //     id: -1,
                        //     fullname: '全部'
                        // });

                        t.loadData();
                    }
                });
            }
        });

        axios.get('employee/getReviewStats').then(res => {
            if (res.data.status == 1) {
                t.stats = res.data.options.stats;
                let config = {
                    'sup': 0,
                    'field_work': 1,
                    'shift': 2,
                    'schedule': 4,
                    'leave': 3,
                };
                let selected = false;
                for (const key in t.stats) {
                    t.list.type[config[key]].count = t.stats[key];
                    if (t.stats[key] > 0 && !selected) {
                        t.search.type = t.list.type[config[key]];
                        selected = true;
                    }
                }
            }
        });

    },
    activated() {
    },
    methods: {
        loadData() {
            let t = this;

            let s = t.search;

            let params = {};

            if (s.status && s.status.id > -1)
                params.status = s.status.id;

            if (s.employee && s.employee.id > -1)
                params.employee_id = s.employee.id;

            if (t.search.type.id == 1) {
                axios.get('clockInSup?_with=employee,mgr', { params: params }).then(res => {
                    if (res.data.status == 1) {
                        let arr = res.data.options.items;
                        arr.forEach(item => {
                            item.status_text = t.dict.status[item.status].text;
                        });
                        t.list.item = arr;
                    }
                });
            } else if (t.search.type.id == 2) {
                axios.get('clockInFieldWork?_with=employee,mgr', { params: params }).then(res => {
                    if (res.data.status == 1) {
                        let arr = res.data.options.items;
                        arr.forEach(item => {
                            item.status_text = t.dict.status[item.status].text;
                        });
                        t.list.item = arr;
                    }
                });

            }
            else if (t.search.type.id == 3) {
                axios.get('clockInShift?_with=employee,mgr', { params: params }).then(res => {
                    if (res.data.status == 1) {
                        let arr = res.data.options.items;
                        arr.forEach(item => {
                            item.status_text = t.dict.status[item.status].text;
                        });
                        t.list.item = arr;
                    }
                });
            }
            else if (t.search.type.id == 5) {
                axios.get('clockInLeave?_with=employee,mgr', { params: params }).then(res => {
                    if (res.data.status == 1) {
                        let arr = res.data.options.items;
                        arr.forEach(item => {
                            item.status_text = t.dict.status[item.status].text;
                            item.leave_data = JSON.parse(item.leave_data);
                        });
                        t.list.item = arr;
                    }
                });
            }
            else if (t.search.type.id == 4) {

                t.attScheduleReady = false;

                let arr = t.search.attMonth.split('-');

                params = {
                    'month': arr[1],
                    'year': arr[0]
                };

                axios.get('attScheduleReview', { params: params }).then(res => {

                    if (res.data.status == 1) {

                        let arr = res.data.options.items;

                        t.list.employee2 = [];

                        arr.forEach(item => {
                            if (item.status == 0) {
                                let employee = t.dict.employee[item.employee_id];
                                if (employee)
                                    t.list.employee2.push(employee);
                            }
                        });

                        if (t.search.employee) {
                            t.attScheduleReady = true;
                        }
                        else if (t.list.employee2.length > 0) {
                            t.search.employee = t.list.employee2[0];
                            t.selectEmployee(null, null, t.search.employee);
                            t.attScheduleReady = true;
                        }

                    }
                });

            }


        },

        confirm(item) {

            let t = this;

            if (t.search.type.id == 1)
                A.safety(t.t('打刻申請を通すことを確認しますか？')).then(function (res) {
                    if (res.isConfirmed) {
                        axios.post('clockIn/confirmSup/' + item.id).then(res => {
                            if (res.data.status == 1) {
                                item.status = 1;
                            }
                        });
                    }
                });
            else if (t.search.type.id == 2)
                A.safety(t.t('この申請を承認してもよろしいですか？')).then(function (res) {
                    if (res.isConfirmed) {
                        axios.post('clockIn/confirmFieldWork/' + item.id).then(res => {
                            if (res.data.status == 1) {
                                item.status = 1;
                            }
                        });
                    }
                });
            else if (t.search.type.id == 3)
                A.safety(t.t('この申請を承認してもよろしいですか？')).then(function (res) {
                    if (res.isConfirmed) {
                        axios.post('clockIn/confirmShift/' + item.id).then(res => {
                            if (res.data.status == 1) {
                                item.status = 1;
                            }
                        });
                    }
                });
        },

        reject(item) {

            let t = this;

            if (t.search.type.id == 1)
                A.safety(t.t('打刻申請を却下することを確認しますか？')).then(function (res) {
                    if (res.isConfirmed) {
                        axios.post('clockIn/rejectSup/' + item.id).then(res => {
                            if (res.data.status == 1) {
                                item.status = 2;
                            }
                        });
                    }
                });
            else if (t.search.type.id == 2)
                A.safety(t.t('この申請を却下してもよろしいですか？')).then(function (res) {
                    if (res.isConfirmed) {
                        axios.post('clockIn/rejectFieldWork/' + item.id).then(res => {
                            if (res.data.status == 1) {
                                item.status = 2;
                            }
                        });
                    }
                });
            else if (t.search.type.id == 3)
                A.safety(t.t('この申請を却下してもよろしいですか？')).then(function (res) {
                    if (res.isConfirmed) {
                        axios.post('clockIn/rejectShift/' + item.id).then(res => {
                            if (res.data.status == 1) {
                                item.status = 2;
                            }
                        });
                    }
                });
        },

        selectEmployee(e, arr, v) {

            if (!v) {
                if (arr[0] == 0 && arr[1] == 0) {
                    v = null;
                }
                else {
                    v = this.list.unit2[arr[0]].children[arr[1]];
                }
            }

            this.search.employee = v;
            this.showEmployeeSelector = false;

            if (this.search.type.id == 4) {
                this.attScheduleReady = false;
                setTimeout(() => {
                    this.attScheduleReady = true;
                }, 50)
            }
            else {
                this.loadData();
            }

        },

        attScheduleConfirmed() {
            let t = this;
            t.list.employee2.remove(t.search.employee);
        },

        nextReview() {
            let t = this;
            let i = t.list.employee2.indexOf(t.search.employee);

            if (t.list.employee2.length <= 1) {
                A.show('これ以上審査が必要な勤務表はありません。', '', 'info');
                return;
            }

            if (i >= 0) {
                let item = t.list.employee2.splice(i, 1);
                t.list.employee2.push(...item);
            }

            if (t.list.employee2.length > 0)
                t.selectEmployee(null, null, t.list.employee2[0]);

        },

        formatter(type, val) {
            if (type === 'year') {
                return `${val}年`;
            } else if (type === 'month') {
                return `${val}月`;
            }
            return val;
        },

        onMonthChanged() {
            this.search.attMonth = this.selectedMonth.format('yyyy-MM')
            this.loadData();
        }
    },
    data() {
        return {
            stats: {
                sup: 0,
                schedule: 0,
                field_work: 0,
                shift: 0
            },
            attScheduleReady: false,
            busying: false,
            showEmployeeSelector: false,
            showStatusPopover: false,
            showAttMonthPopover: false,
            showTypePopover: false,
            dict: {
                status: {},
                employee: {},
                unit: {},
            },
            list: {
                unit: [],
                unit2: [],
                item: [],
                type: [

                ],
                status: [
                    {
                        'id': -1,
                        'text': '全部'
                    },
                    {
                        'id': 0,
                        'text': '承認待ち'
                    },
                    {
                        'id': 1,
                        'text': '承認済'
                    },
                    {
                        'id': 2,
                        'text': '却下'
                    }
                ],
                employee: [],
                employee2: [],
            },
            search: {
                employee: null,
                status: null,
                type: null,
                attMonth: null
            },

            selectedMonth: null,
            minDate: new Date('2025-04-01')

        };
    },
};
